import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Row } from "antd";
import Spin from "components/common/Spin";
import Setting from "./Setting";
import store from "store";
import { patchUser, showUser, emptyUser } from "../Module";
import { connect } from "react-redux";

import {
  indexUserFinancials,
  emptyUserFinancials,
  destroyUserFinancial,
} from "../Module";

@authorize
@connect(
  (state) => ({
    financialInfos: state.Basic.Personnel.financialInfos,
    user: state.Basic.Personnel.user,
  }),
  {
    index: indexUserFinancials,
    empty: emptyUserFinancials,
    destroy: destroyUserFinancial,
    show: showUser,
    empty: emptyUser,
  }
)
@autobind
/**
 *
 * @class ReportsFormContainer
 * @extends PureComponent
 */
export default class SettingWrapper extends React.PureComponent {
  static propTypes = {
    form: PropTypes.object,
    onClick: PropTypes.func,
    reload: PropTypes.func,
    onCancel: PropTypes.func,
    loading: PropTypes.bool,
    title: PropTypes.string,
    formValue: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: null,
      bardia: "",
    };
  }

  componentDidMount() {
    const { index, item, show } = this.props;
    console.log("itemitemitemitemitem", item);

    // this.setState({
    //   bardia: item,
    // });
    // show(
    //   item.id,
    //   {
    //     includes: ["taInfo", "profile", "phones"],
    //   },
    //   () => this.setState({ loading: false })
    // );
    // index(item.id, (err) => !err && this.setState({ loading: false }));
  }

  componentDidUpdate() {
    // const { index, item, show, userItem } = this.props;
    // this.setState({
    //   bardia: item,
    // });
    // console.log("231231231231231", item);
    // console.log("user ", this.props.user);
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const { item, title, loading } = this.props;
    const { bardia } = this.state;
    // console.log(form);
    return (
      <Card
        className="wrapper"
        title={title}
        extra={
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div>
              {item?.profile?.firstName} {item?.profile?.lastName}
            </div>
            {/* <div>
              <Button.Group>
                <Button type="default" onClick={() => onCancel()}>
                  {app.translate("main.Cancel")}
                </Button>
              </Button.Group>
            </div> */}
          </div>
        }
      >
        <Spin spinning={false}>
          <Setting
            item={item}
            ceilingOvertime={this.props.user?.profile?.ceilingOvertime}

            // formFields={form}
            // onClick={onClick}
            // formValue={formValue}
            // getPositionId={getPositionId}
            // {...rest}
          />
        </Spin>
      </Card>
    );
  }
}
